module.exports = __webpack_public_path__ + "static/media/numeros-brasil-v2.b5a940b6.jpg";